import React, { useCallback, useEffect, useState } from "react";
import Box from "./Box";

interface Props {
    active: boolean
    onClick: () => void
}

const Dot = ({ active, onClick }: Props) => {
    return (
        <Box onClick={onClick} actionIcon borderRadius='99px' bg={active ? '#1B84FF' : '#00000070'} width='10px' height='10px'>&nbsp;</Box>
    )
}

export default Dot;